import { Icon, IconButton, Tooltip } from "@material-ui/core";
import React from "react";
import PrimaryTheme from "../Themes/Primary";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { DateRange } from "react-date-range";
import { useSelector } from "react-redux";
import "./filters.scss";
import { DebounceInput } from "react-debounce-input";
import Input from "./Input";
export default function Filters(props: FilterProps) {
  const getTradePartnerLocation = useSelector(
    (state: any) => state.getTradePartnerLocation
  );
  const locations = getTradePartnerLocation && getTradePartnerLocation.result;
  const onMouseEnter = () => {
    // setShow(!show);
    const el = document.querySelector(".date-range-holder");
    el?.classList.remove("d-none");
  };

  const onMouseOut = () => {
    const el = document.querySelector(".date-range-holder");
    el?.classList.add("d-none");
  };

  return (
    <div className="row justify-content-end">
      <div className="col-md-12 p-0 mb-3">
        <div className="row m-0">
          {props.hasDownloads && (
            <div className="col-md-7">
              <button
                className="btn btn-light download__button"
                onClick={props.onDownload}
                style={{
                  color: PrimaryTheme.primary,
                }}
              >
                <div className="row justify-content-center align-items-center m-0">
                  <Icon
                    fontSize="small"
                    style={{
                      marginRight: 5,
                    }}
                  >
                    download
                  </Icon>{" "}
                  {props.name}
                </div>
              </button>
            </div>
          )}

          {!props.hasDownloads && !props.hasSubtitle && (
            <div className="col-md-7">
              <h5 className="text-uppercase">{props.name}</h5>
            </div>
          )}

          {!props.hasDownloads && props.hasSubtitle && (
            <div className="col-md-7">
              <h5 className="text-uppercase">{props.name}</h5>
              <p
                style={{
                  fontSize: PrimaryTheme.fontSizes?.small,
                }}
              >
                {props.subtitle}
              </p>
            </div>
          )}
          {props.isLogs && (
            <div className="col-5" style={{ textAlign: "end" }}>
              {" "}
              <Input
                type="button"
                isInput
                value={"Log New Complaint"}
                onClick={props.handleOpenModal}
                style={{
                  background: PrimaryTheme.primary,
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                  color: PrimaryTheme.white,
                }}
                className="text-bold border-0 col-md-6"
              />
            </div>
          )}

          {props.hasSearch && (
            <div className="col-md-5 ">
              <div className="row m-0 justify-content-space">
                <div className="input-group bg-light">
                  <div className="input-group-prepend bg-light">
                    <span
                      className="input-group-text bg-light border-0 border-radius-none text-bold text-dark"
                      id="basic-addon1"
                    >
                      {" "}
                      <Icon>search</Icon>{" "}
                    </span>
                  </div>
                  <form
                    autoComplete="off"
                    style={{ width: "50%" }}
                    className="search__filter"
                  >
                    <DebounceInput
                      minLength={0}
                      value={props.searchState}
                      debounceTimeout={500}
                      onChange={props.handleSearch}
                      type="text"
                      inputMode="text"
                      autoComplete="off"
                      placeholder="Search here..."
                      className="form-control outline-0 bg-light border-0"
                    />

                    {/* <input type="text" inputMode="text" autoComplete="off" placeholder="Search here..." value={props.searchState} className="form-control outline-0 bg-light border-0" onChange={props.handleSearch} /> */}
                  </form>

                  <div className="input-group-append bg-light ml-auto">
                    <span
                      className="input-group-text  border-radius-none small text-white pointer"
                      style={{
                        backgroundColor: PrimaryTheme.primary,
                        fontSize: PrimaryTheme.fontSizes?.body,
                      }}
                      id="basic-addon1"
                      onClick={props.onClick}
                    >
                      {" "}
                      <Icon
                        style={{
                          marginRight: 5,
                        }}
                      >
                        subject
                      </Icon>{" "}
                      Filter
                    </span>
                    <Tooltip title="Reset">
                      <IconButton onClick={props.onClear}>
                        <Icon fontSize="small">refresh</Icon>
                      </IconButton>
                    </Tooltip>
                  </div>
                </div>
              </div>
            </div>
          )}

          {props.isLogs && (
            <React.Fragment>
              <div className="col-12">
                <div className="row">
                  <div className="col-3">
                    <div
                      className="col-md-12 text-right pt-2"
                      onMouseEnter={onMouseOut}
                    >
                      <div className="input-group bg-light w-100">
                        <div className="input-group-prepend bg-light">
                          <span
                            className="input-group-text bg-warning border-0 border-radius-none text-bold text-dark"
                            id="basic-addon1"
                          >
                            Status
                          </span>
                        </div>

                        <select
                          name="hasPos"
                          id="hasPos"
                          value={props.status}
                          onChange={props.statusChange}
                          className="custom-select bg-light outline-0 border-0"
                        >
                          <option value={""}>Select Status</option>
                          <option value={"Resolved"}>{"Resolved"}</option>
                          <option value={"To Do"}>{"To Do"}</option>
                          <option value={"Pending"}>{"Pending"}</option>
                          <option value={"In progress"}>{"In progress"}</option>
                          <option value={"Resolved - (Successful)"}>
                            {"Resolved - (Successful)"}
                          </option>
                          <option value={"Resolved - (Failed)"}>
                            {"Resolved - (Failed)"}
                          </option>
                          <option value={"Resolved - (Reversed)"}>
                            {"Resolved - (Reversed)"}
                          </option>
                          <option value={"WAITING ON SUPPORT"}>
                            {"WAITING ON SUPPORT"}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-4">
                    <div
                      className="col-md-12 text-right pt-2"
                      onMouseEnter={onMouseOut}
                    >
                      <div className="input-group bg-light w-100">
                        <div className="input-group-prepend bg-light">
                          <span
                            className="input-group-text bg-warning border-0 border-radius-none text-bold text-dark"
                            id="basic-addon1"
                          >
                            Type
                          </span>
                        </div>

                        <select
                          name="logType"
                          id="logType"
                          value={props.logType}
                          onChange={props.logTypeChange}
                          className="custom-select bg-light outline-0 border-0"
                        >
                          <option value={0}>Transfer/Bills/POS/Savings</option>
                          <option value={2}>General</option>
                          <option value={6}>Bill Payment</option>
                          <option value={1}>Transfer</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-5">
                    <div className="col-md-12">
                      <div className="row m-0 justify-content-space">
                        <div className="input-group bg-light">
                          <div className="input-group-prepend bg-light">
                            <span
                              className="input-group-text bg-light border-0 border-radius-none text-bold text-dark"
                              id="basic-addon1"
                            >
                              {" "}
                              <Icon>search</Icon>{" "}
                            </span>
                          </div>
                          <form
                            autoComplete="off"
                            style={{ width: "50%" }}
                            className="search__filter"
                          >
                            <DebounceInput
                              minLength={3}
                              debounceTimeout={500}
                              onChange={props.handleSearch}
                              type="text"
                              inputMode="text"
                              autoComplete="off"
                              placeholder="Search here..."
                              className="form-control outline-0 bg-light border-0"
                            />

                            {/* <input type="text" inputMode="text" autoComplete="off" placeholder="Search here..." value={props.searchState} className="form-control outline-0 bg-light border-0" onChange={props.handleSearch} /> */}
                          </form>

                          <div className="input-group-append bg-light ml-auto">
                            <span
                              className="input-group-text  border-radius-none small text-white pointer"
                              style={{
                                backgroundColor: PrimaryTheme.primary,
                                fontSize: PrimaryTheme.fontSizes?.body,
                              }}
                              id="basic-addon1"
                              onClick={props.onClick}
                            >
                              {" "}
                              <Icon
                                style={{
                                  marginRight: 5,
                                }}
                              >
                                subject
                              </Icon>{" "}
                              Filter
                            </span>
                            <Tooltip title="Reset">
                              <IconButton onClick={props.onClear}>
                                <Icon fontSize="small">refresh</Icon>
                              </IconButton>
                            </Tooltip>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          )}
        </div>
      </div>

      {props.isPOS && (
        <React.Fragment>
          <div
            className="col-12"
            style={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <div className="row">
              <div
                className="col-md-5 col-12 text-right pt-2"
                onMouseEnter={onMouseOut}
                style={{ marginBottom: "10px" }}
              >
                <div className="input-group bg-light w-100">
                  <div className="input-group-prepend bg-light">
                    <span
                      className="input-group-text bg-primary  border-0 border-radius-none text-bold text-white"
                      id="basic-addon1"
                    >
                      {" "}
                      Location
                    </span>
                  </div>

                  <select
                    name="state"
                    id="state"
                    value={props.posState}
                    onChange={props.posStateChange}
                    className="custom-select bg-light outline-0 border-0"
                  >
                    <option value={0}>Select Location</option>
                    {locations &&
                      locations.map((list: any) => (
                        <option value={list.id}>{list.name}</option>
                      ))}

                    {/* <option value={1}>Stopped</option> */}
                  </select>
                </div>
              </div>

              <div className="col-md-7 col-12">
                <div className="row m-0 justify-content-space">
                  <div className="input-group bg-light">
                    <div className="input-group-prepend bg-light">
                      <span
                        className="input-group-text bg-light border-0 border-radius-none text-bold text-dark"
                        id="basic-addon1"
                      >
                        {" "}
                        <Icon>search</Icon>{" "}
                      </span>
                    </div>
                    <form
                      autoComplete="off"
                      style={{ width: "50%" }}
                      className="search__filter"
                    >
                      <input
                        type="text"
                        inputMode="text"
                        autoComplete="off"
                        placeholder="Search here..."
                        value={props.searchState}
                        className="form-control outline-0 bg-light border-0"
                        onChange={props.handleSearch}
                      />
                    </form>

                    <div className="input-group-append bg-light ml-auto">
                      <span
                        className="input-group-text  border-radius-none small text-white pointer"
                        style={{
                          backgroundColor: PrimaryTheme.primary,
                          fontSize: PrimaryTheme.fontSizes?.body,
                        }}
                        id="basic-addon1"
                        onClick={props.onClick}
                      >
                        {" "}
                        <Icon
                          style={{
                            marginRight: 5,
                          }}
                        >
                          subject
                        </Icon>{" "}
                        Filter
                      </span>
                      <Tooltip title="Reset">
                        <IconButton onClick={props.onClear}>
                          <Icon fontSize="small">refresh</Icon>
                        </IconButton>
                      </Tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {props.poshasStatus && (
            <div className="col-md-3 text-right pt-2" onMouseEnter={onMouseOut}>
              <div className="input-group bg-light w-100">
                <div className="input-group-prepend bg-light">
                  <span
                    className="input-group-text bg-primary border-0 border-radius-none text-bold text-white"
                    id="basic-addon1"
                  >
                    {" "}
                    Status
                  </span>
                </div>

                <select
                  name="posTarget"
                  id="posTarget"
                  value={props.posTarget}
                  onChange={props.posTargetChange}
                  className="custom-select bg-light outline-0 border-0"
                >
                  <option value={0}>Ontrack/BH</option>
                  <option value={2}>On Track</option>
                  <option value={1}>Behind</option>
                </select>
              </div>
            </div>
          )}
        </React.Fragment>
      )}

      {props.isRequest && (
        <React.Fragment>
          <div className="col-md-3 text-right pt-2" onMouseEnter={onMouseOut}>
            <div className="input-group bg-light w-100">
              <div className="input-group-prepend bg-light">
                <span
                  className="input-group-text bg-primary border-0 border-radius-none text-bold text-white"
                  id="basic-addon1"
                >
                  Recommended
                </span>
              </div>
              <select
                name="recommended"
                id="recommended"
                value={props.recommended}
                onChange={props.onRecommend}
                className="custom-select bg-light outline-0 border-0"
              >
                <option>Select Y/N</option>
                <option value={1}>Yes</option>
                <option value={0}>No</option>
              </select>
            </div>
          </div>

          <div className="col-md-3 text-right pt-2" onMouseEnter={onMouseOut}>
            <div className="input-group bg-light w-100">
              <div className="input-group-prepend bg-light">
                <span
                  className="input-group-text bg-primary border-0 border-radius-none text-bold text-white"
                  id="basic-status"
                >
                  Status
                </span>
              </div>

              <select
                name="status"
                id="status"
                value={props.status}
                onChange={props.statusChange}
                className="custom-select bg-light outline-0 border-0"
              >
                <option>All</option>
                <option value={1}>Pending</option>
                <option value={3}>Approved</option>
                <option value={7}>Assigned</option>
                <option value={9}>Treated For Approved</option>
                <option value={2}>Declined</option>
              </select>
            </div>
          </div>
        </React.Fragment>
      )}
      {props.hasDate && (
        <React.Fragment>
          <div
            className={
              props.haschangeWidth
                ? `${props.haschangeWidth} text-right pt-2`
                : "col-md-3 text-right pt-2"
            }
          >
            <form autoComplete="off">
              <div
                className="input-group bg-light w-100 position-relative"
                onClick={onMouseEnter}
              >
                <div className="input-group-prepend bg-light">
                  <span
                    className="input-group-text bg-primary border-0 border-radius-none text-bold text-white"
                    id="basic-addon1"
                  >
                    Date
                  </span>
                </div>

                <input
                  type="text"
                  autoComplete="off"
                  placeholder="Today/Week/Custom"
                  className="form-control outline-0 bg-light border-0 date-range-hover"
                  onClick={onMouseEnter}
                />

                <div
                  className="position-absolute bg-white d-none animated fadeIn date-range-holder"
                  style={{
                    zIndex: 5000,
                    top: 50,
                    paddingBottom: 100,
                  }}
                  onMouseLeave={onMouseOut}
                >
                  <DateRange
                    onChange={props.handleSelect}
                    showSelectionPreview={false}
                    moveRangeOnFirstSelection={false}
                    twoStepChange
                    // months={2}
                    ranges={props.ranges}
                    direction="horizontal"
                  />
                </div>
              </div>
            </form>
          </div>
        </React.Fragment>
      )}
      {props.isTransaction && (
        <React.Fragment>
          <div className="col-md-3 text-right pt-2" onMouseEnter={onMouseOut}>
            <div className="input-group bg-light w-100">
              <div className="input-group-prepend bg-light">
                <span
                  className="input-group-text bg-primary border-0 border-radius-none text-bold text-white"
                  id="basic-addon1"
                >
                  Type
                </span>
              </div>

              <select
                name="hasPos"
                id="hasPos"
                value={props.typeState}
                onChange={props.onTypeChange}
                className="custom-select bg-light outline-0 border-0"
              >
                <option value={0}>Select Type</option>
                {props.typeItems &&
                  props.typeItems.map((item: any, index: number) => (
                    <option key={index} value={item.id}>
                      {item.name}
                    </option>
                  ))}
              </select>
            </div>
          </div>

          <div className="col-md-3 pt-2" onMouseEnter={onMouseOut}>
            <form autoComplete="off">
              <div className="input-group bg-light">
                <div className="input-group-prepend bg-light">
                  <span
                    className="input-group-text bg-primary border-0 border-radius-none text-bold text-white"
                    id="basic-addon1"
                  >
                    {" "}
                    Amount{" "}
                  </span>
                </div>
                <input
                  type="number"
                  placeholder="Amount"
                  autoComplete="off"
                  min="0"
                  name="amount"
                  value={props.amount}
                  onChange={props.amountChange}
                  className="form-control outline-0 bg-light border-0"
                />
              </div>
            </form>
          </div>

          <div className="col-md-3 text-right pt-2">
            <form autoComplete="off">
              <div
                className="input-group bg-light w-100 position-relative"
                onClick={onMouseEnter}
              >
                <div className="input-group-prepend bg-light">
                  <span
                    className="input-group-text bg-primary border-0 border-radius-none text-bold text-white"
                    id="basic-addon1"
                  >
                    Date
                  </span>
                </div>

                <input
                  type="text"
                  autoComplete="off"
                  placeholder="Today/Week/Custom"
                  className="form-control outline-0 bg-light border-0 date-range-hover"
                  onClick={onMouseEnter}
                />

                <div
                  className="position-absolute bg-white d-none animated fadeIn date-range-holder"
                  style={{
                    zIndex: 5000,
                    top: 50,
                    paddingBottom: 100,
                  }}
                  onMouseLeave={onMouseOut}
                >
                  <DateRange
                    onChange={props.handleSelect}
                    showSelectionPreview={false}
                    moveRangeOnFirstSelection={false}
                    twoStepChange
                    // months={2}
                    ranges={props.ranges}
                    direction="horizontal"
                  />
                </div>
              </div>
            </form>
          </div>

          <div className="col-md-3 text-right pt-2" onMouseEnter={onMouseOut}>
            <div className="input-group bg-light w-100">
              <div className="input-group-prepend bg-light">
                <span
                  className="input-group-text bg-primary border-0 border-radius-none text-bold text-white"
                  id="basic-addon1"
                >
                  Status
                </span>
              </div>

              <select
                name="transStatus"
                id="transStatus"
                value={props.transactionStatus}
                onChange={props.transactionStatusChange}
                className="custom-select bg-light outline-0 border-0"
              >
                <option value={0}>Select Status</option>
                <option value={3}>Successful</option>
                <option value={2}>Failed</option>
                <option value={1}>Pending</option>
              </select>
            </div>
          </div>
        </React.Fragment>
      )}
      {props.isDashboardPOSTransactions && (
        <React.Fragment>
          <div className="col-12">
            <div className="row">
              <div className="col-md-7 col-12" style={{ marginBottom: "20px" }}>
                <div className="col-md-12">
                  <div className="row m-0 justify-content-space">
                    <div className="input-group bg-light">
                      <div className="input-group-prepend bg-light">
                        <span
                          className="input-group-text bg-light border-0 border-radius-none text-bold text-dark"
                          id="basic-addon1"
                        >
                          {" "}
                          <Icon>search</Icon>{" "}
                        </span>
                      </div>
                      <form
                        autoComplete="off"
                        style={{ width: "50%" }}
                        className="search__filter"
                      >
                        <DebounceInput
                          minLength={3}
                          debounceTimeout={500}
                          onChange={props.handleSearch}
                          type="text"
                          value={props.searchData}
                          inputMode="text"
                          autoComplete="off"
                          placeholder="Search here..."
                          className="form-control outline-0 bg-light border-0"
                        />
                      </form>

                      {/* <div className="input-group-append bg-light ml-auto">
                        <span
                          className="input-group-text  border-radius-none small text-white pointer"
                          style={{
                            backgroundColor: PrimaryTheme.primary,
                            fontSize: PrimaryTheme.fontSizes?.body,
                          }}
                          id="basic-addon1"
                          onClick={props.onClick}
                        >
                          {" "}
                          <Icon
                            style={{
                              marginRight: 5,
                            }}
                          >
                            subject
                          </Icon>
                        </span>
                        <Tooltip title="Reset">
                          <IconButton onClick={props.onClear}>
                            <Icon fontSize="small">refresh</Icon>
                          </IconButton>
                        </Tooltip>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* date div */}
              {/* <div
                className=" col-md-5 col-12"
                style={{ marginBottom: "20px" }}
              >
                <div className="col-md-12 col-12">
                  <form autoComplete="off">
                    <div
                      className="input-group bg-light w-100 position-relative"
                      onClick={onMouseEnter}
                    >
                      <div className="input-group-prepend bg-light">
                        <span
                          className="input-group-text bg-primary border-0 border-radius-none text-bold text-white"
                          id="basic-addon1"
                        >
                          Date
                        </span>
                      </div>

                      <input
                        type="text"
                        autoComplete="off"
                        placeholder="Today/Week/Custom"
                        className="form-control outline-0 bg-light border-0 date-range-hover"
                        onClick={onMouseEnter}
                      />

                      <div
                        className="position-absolute bg-white d-none animated fadeIn date-range-holder"
                        style={{
                          zIndex: 5000,
                          top: 50,
                          paddingBottom: 100,
                        }}
                        onMouseLeave={onMouseOut}
                      >
                        <DateRange
                          onChange={props.handleSelect}
                          showSelectionPreview={false}
                          moveRangeOnFirstSelection={false}
                          twoStepChange
                          // months={2}
                          ranges={props.ranges}
                          direction="horizontal"
                        />
                      </div>
                    </div>
                  </form>
                </div>
              </div> */}
            </div>
          </div>
        </React.Fragment>
      )}
      {props.isDashboardTransfer && (
        <React.Fragment>
          <div className="col-12">
            <div className="row">
              <div className="col-md-7 col-12" style={{ marginBottom: "20px" }}>
                <div className="col-md-12">
                  <div className="row m-0 justify-content-space">
                    <div className="input-group bg-light">
                      <div className="input-group-prepend bg-light">
                        <span
                          className="input-group-text bg-light border-0 border-radius-none text-bold text-dark"
                          id="basic-addon1"
                        >
                          {" "}
                          <Icon>search</Icon>{" "}
                        </span>
                      </div>
                      <form
                        autoComplete="off"
                        style={{ width: "50%" }}
                        className="search__filter"
                      >
                        <DebounceInput
                          minLength={3}
                          debounceTimeout={500}
                          onChange={props.handleSearchTransfer}
                          type="text"
                          value={props.searchDataTransfer}
                          inputMode="text"
                          autoComplete="off"
                          placeholder="Search here..."
                          className="form-control outline-0 bg-light border-0"
                        />
                      </form>

                      {/* <div className="input-group-append bg-light ml-auto">
                        <span
                          className="input-group-text  border-radius-none small text-white pointer"
                          style={{
                            backgroundColor: PrimaryTheme.primary,
                            fontSize: PrimaryTheme.fontSizes?.body,
                          }}
                          id="basic-addon1"
                          onClick={props.onClick}
                        >
                          {" "}
                          <Icon
                            style={{
                              marginRight: 5,
                            }}
                          >
                            subject
                          </Icon>
                        </span>
                        <Tooltip title="Reset">
                          <IconButton onClick={props.onClear}>
                            <Icon fontSize="small">refresh</Icon>
                          </IconButton>
                        </Tooltip>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* date div */}
              {/* <div
                className=" col-md-5 col-12"
                style={{ marginBottom: "20px" }}
              >
                <div className="col-md-12 col-12">
                  <form autoComplete="off">
                    <div
                      className="input-group bg-light w-100 position-relative"
                      onClick={onMouseEnter}
                    >
                      <div className="input-group-prepend bg-light">
                        <span
                          className="input-group-text bg-primary border-0 border-radius-none text-bold text-white"
                          id="basic-addon1"
                        >
                          Date
                        </span>
                      </div>

                      <input
                        type="text"
                        autoComplete="off"
                        placeholder="Today/Week/Custom"
                        className="form-control outline-0 bg-light border-0 date-range-hover"
                        onClick={onMouseEnter}
                      />

                      <div
                        className="position-absolute bg-white d-none animated fadeIn date-range-holder"
                        style={{
                          zIndex: 5000,
                          top: 50,
                          paddingBottom: 100,
                        }}
                        onMouseLeave={onMouseOut}
                      >
                        <DateRange
                          onChange={props.handleSelect}
                          showSelectionPreview={false}
                          moveRangeOnFirstSelection={false}
                          twoStepChange
                          // months={2}
                          ranges={props.ranges}
                          direction="horizontal"
                        />
                      </div>
                    </div>
                  </form>
                </div>
              </div> */}
            </div>
          </div>
        </React.Fragment>
      )}
      {props.isLocationDetails && (
        <React.Fragment>
          {/* date form */}
          <div className="col-md-3 text-right pt-2">
            <form autoComplete="off">
              <div
                className="input-group bg-light w-100 position-relative"
                onClick={onMouseEnter}
              >
                <div className="input-group-prepend bg-light">
                  <span
                    className="input-group-text bg-primary border-0 border-radius-none text-bold text-white"
                    id="basic-addon1"
                  >
                    Date
                  </span>
                </div>

                <input
                  type="text"
                  autoComplete="off"
                  placeholder="Today/Week/Custom"
                  className="form-control outline-0 bg-light border-0 date-range-hover"
                  onClick={onMouseEnter}
                />

                <div
                  className="position-absolute bg-white d-none animated fadeIn date-range-holder"
                  style={{
                    zIndex: 5000,
                    top: 50,
                    paddingBottom: 100,
                  }}
                  onMouseLeave={onMouseOut}
                >
                  <DateRange
                    onChange={props.handleSelect}
                    showSelectionPreview={false}
                    moveRangeOnFirstSelection={false}
                    twoStepChange
                    // months={2}
                    ranges={props.ranges}
                    direction="horizontal"
                  />
                </div>
              </div>
            </form>
          </div>
          {
            <div className="col-md-3 text-right pt-2" onMouseEnter={onMouseOut}>
              <div className="input-group bg-light w-100">
                <div className="input-group-prepend bg-light">
                  <span
                    className="input-group-text bg-primary border-0 border-radius-none text-bold text-white"
                    id="basic-addon1"
                  >
                    Active
                  </span>
                </div>

                <select
                  name="posTarget"
                  id="posTarget"
                  value={props.posTarget}
                  onChange={props.posTargetChange}
                  className="custom-select bg-light outline-0 border-0"
                >
                  <option value={0}>Ontrack/BH</option>
                  <option value={2}>On Track</option>
                  <option value={1}>Behind</option>
                </select>
              </div>
            </div>
          }

          {/* Reference form */}
          {/* {
        props.poshasReference&& <div className="col-md-3 text-right pt-2" onMouseEnter={onMouseOut}>
        <div className="input-group bg-light w-100">
          <div className="input-group-prepend bg-light">
            <span className="input-group-text bg-primary border-0 border-radius-none text-bold text-white"
              id="basic-addon1" style={{zIndex:1000}}>Reference</span>
          </div>

          <form autoComplete="off" style={{ width: "55%" }}>
  <input type="text" inputMode="text" autoComplete="off" placeholder="Search here..." value={props.searchState} className="form-control outline-0 bg-light border-0" onChange={props.handleSearch} />
</form>
        </div>
      </div>
      } */}

          {/* Phone form */}
          <div className="col-md-3 text-right pt-2" onMouseEnter={onMouseOut}>
            <div className="input-group bg-light w-100">
              <div className="input-group-prepend bg-light">
                <span
                  className="input-group-text bg-primary border-0 border-radius-none text-bold text-white"
                  id="basic-addon1"
                  style={{ zIndex: 1000 }}
                >
                  Phone
                </span>
              </div>

              <form autoComplete="off" style={{ width: "67%" }}>
                <input
                  type="text"
                  inputMode="text"
                  autoComplete="off"
                  placeholder="Search here..."
                  value={props.searchState}
                  className="form-control outline-0 bg-light border-0"
                  onChange={props.handleSearch}
                />
              </form>
            </div>
          </div>
          {/* tids form */}
          <div className="col-md-3 text-right pt-2" onMouseEnter={onMouseOut}>
            <div className="input-group bg-light w-100">
              <div className="input-group-prepend bg-light">
                <span
                  className="input-group-text bg-primary border-0 border-radius-none text-bold text-white"
                  id="basic-addon1"
                  style={{ zIndex: 1000 }}
                >
                  State
                </span>
              </div>

              <form autoComplete="off" style={{ width: "67%" }}>
                <input
                  type="text"
                  inputMode="text"
                  autoComplete="off"
                  placeholder="State/List"
                  value={props.searchState}
                  className="form-control outline-0 bg-light border-0"
                  onChange={props.handleSearch}
                />
              </form>
            </div>
          </div>
        </React.Fragment>
      )}

      {props.isPosTransfer && (
        <React.Fragment>
          <div
            className="col-12"
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <div className="row">
              <div
                className="col-md-5 col-12 text-right pt-2"
                onMouseEnter={onMouseOut}
                style={{ marginBottom: "10px" }}
              >
                <div className="input-group bg-light w-100">
                  <div className="input-group-prepend bg-light">
                    <span
                      className="input-group-text bg-primary  border-0 border-radius-none text-bold text-white"
                      id="basic-addon1"
                    >
                      {" "}
                      Location
                    </span>
                  </div>

                  <select
                    name="state"
                    id="state"
                    value={props.posState}
                    onChange={props.posStateChange}
                    className="custom-select bg-light outline-0 border-0"
                  >
                    <option value={0}>Select Location</option>
                    {locations &&
                      locations.map((list: any) => (
                        <option value={list.id}>{list.name}</option>
                      ))}

                    {/* <option value={1}>Stopped</option> */}
                  </select>
                </div>
              </div>

              <div className="col-md-7 col-12">
                <div className="row m-0 justify-content-space">
                  <div className="input-group bg-light">
                    <div className="input-group-prepend bg-light">
                      <span
                        className="input-group-text bg-light border-0 border-radius-none text-bold text-dark"
                        id="basic-addon1"
                      >
                        {" "}
                        <Icon>search</Icon>{" "}
                      </span>
                    </div>
                    <form
                      autoComplete="off"
                      style={{ width: "50%" }}
                      className="search__filter"
                    >
                      <input
                        type="text"
                        inputMode="text"
                        autoComplete="off"
                        placeholder="Search here..."
                        value={props.searchState}
                        className="form-control outline-0 bg-light border-0"
                        onChange={props.handlePosTransferSearch}
                      />
                    </form>

                    <div className="input-group-append bg-light ml-auto">
                      <span
                        className="input-group-text  border-radius-none small text-white pointer"
                        style={{
                          backgroundColor: PrimaryTheme.primary,
                          fontSize: PrimaryTheme.fontSizes?.body,
                        }}
                        id="basic-addon1"
                        onClick={props.onClick}
                      >
                        {" "}
                        <Icon
                          style={{
                            marginRight: 5,
                          }}
                        >
                          subject
                        </Icon>{" "}
                        Filter
                      </span>
                      <Tooltip title="Reset">
                        <IconButton onClick={props.onClear}>
                          <Icon fontSize="small">refresh</Icon>
                        </IconButton>
                      </Tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* date form */}
          <div className="col-md-3 text-right pt-2">
            <form autoComplete="off">
              <div
                className="input-group bg-light w-100 position-relative"
                onClick={onMouseEnter}
              >
                <div className="input-group-prepend bg-light">
                  <span
                    className="input-group-text bg-primary border-0 border-radius-none text-bold text-white"
                    id="basic-addon1"
                  >
                    Date
                  </span>
                </div>

                <input
                  type="text"
                  autoComplete="off"
                  placeholder="Today/Week/Custom"
                  className="form-control outline-0 bg-light border-0 date-range-hover"
                  onClick={onMouseEnter}
                />

                <div
                  className="position-absolute bg-white d-none animated fadeIn date-range-holder"
                  style={{
                    zIndex: 5000,
                    top: 50,
                    paddingBottom: 100,
                  }}
                  onMouseLeave={onMouseOut}
                >
                  <DateRange
                    onChange={props.handleSelect}
                    showSelectionPreview={false}
                    moveRangeOnFirstSelection={false}
                    twoStepChange
                    // months={2}
                    ranges={props.ranges}
                    direction="horizontal"
                  />
                </div>
              </div>
            </form>
          </div>
          {props.poshasStatus && (
            <div className="col-md-3 text-right pt-2" onMouseEnter={onMouseOut}>
              <div className="input-group bg-light w-100">
                <div className="input-group-prepend bg-light">
                  <span
                    className="input-group-text bg-primary border-0 border-radius-none text-bold text-white"
                    id="basic-addon1"
                  >
                    {" "}
                    Status
                  </span>
                </div>

                <select
                  name="posTarget"
                  id="posTarget"
                  value={props.posTarget}
                  onChange={props.posTargetChange}
                  className="custom-select bg-light outline-0 border-0"
                >
                  <option value={0}>Ontrack/BH</option>
                  <option value={2}>On Track</option>
                  <option value={1}>Behind</option>
                </select>
              </div>
            </div>
          )}

          {/* Reference form */}
          {props.poshasReference && (
            <div className="col-md-3 text-right pt-2" onMouseEnter={onMouseOut}>
              <div className="input-group bg-light w-100">
                <div className="input-group-prepend bg-light">
                  <span
                    className="input-group-text bg-primary border-0 border-radius-none text-bold text-white"
                    id="basic-addon1"
                    style={{ zIndex: 1000 }}
                  >
                    Reference
                  </span>
                </div>

                <form autoComplete="off" style={{ width: "55%" }}>
                  <input
                    type="text"
                    inputMode="text"
                    autoComplete="off"
                    placeholder="Search here..."
                    value={props.referenceValue}
                    className="form-control outline-0 bg-light border-0"
                    onChange={props.handleRefrenceChange}
                  />
                </form>
              </div>
            </div>
          )}

          {/* Phone form */}
          <div className="col-md-3 text-right pt-2" onMouseEnter={onMouseOut}>
            <div className="input-group bg-light w-100">
              <div className="input-group-prepend bg-light">
                <span
                  className="input-group-text bg-primary border-0 border-radius-none text-bold text-white"
                  id="basic-addon1"
                  style={{ zIndex: 1000 }}
                >
                  Phone
                </span>
              </div>

              <form autoComplete="off" style={{ width: "67%" }}>
                <input
                  type="text"
                  inputMode="text"
                  autoComplete="off"
                  placeholder="Search here..."
                  value={props.phoneValue}
                  className="form-control outline-0 bg-light border-0"
                  onChange={props.handlePhoneSearch}
                />
              </form>
            </div>
          </div>
          {/* tids form */}
          <div className="col-md-3 text-right pt-2" onMouseEnter={onMouseOut}>
            <div className="input-group bg-light w-100">
              <div className="input-group-prepend bg-light">
                <span
                  className="input-group-text bg-primary border-0 border-radius-none text-bold text-white"
                  id="basic-addon1"
                  style={{ zIndex: 1000 }}
                >
                  TID
                </span>
              </div>

              <form autoComplete="off" style={{ width: "67%" }}>
                <input
                  type="text"
                  inputMode="text"
                  autoComplete="off"
                  placeholder="Search with TID"
                  value={props.terminalIdValue}
                  className="form-control outline-0 bg-light border-0"
                  onChange={props.handleSearchTID}
                />
              </form>
            </div>
          </div>
        </React.Fragment>
      )}

      {props.TraderPartnerSearch && (
        <div className="col-md-5 ">
          <div className="row m-0 justify-content-space">
            <div className="input-group bg-light">
              <div className="input-group-prepend bg-light">
                <span
                  className="input-group-text bg-light border-0 border-radius-none text-bold text-dark"
                  id="basic-addon1"
                >
                  {" "}
                  <Icon>search</Icon>{" "}
                </span>
              </div>
              <form
                autoComplete="off"
                style={{ width: "50%" }}
                className="search__filter"
              >
                <DebounceInput
                  minLength={0}
                  value={props.searchContent}
                  debounceTimeout={500}
                  onChange={props.handleTraderPartnerSearchContent}
                  type="text"
                  inputMode="text"
                  autoComplete="off"
                  placeholder="Search here..."
                  className="form-control outline-0 bg-light border-0"
                />

                {/* <input type="text" inputMode="text" autoComplete="off" placeholder="Search here..." value={props.searchState} className="form-control outline-0 bg-light border-0" onChange={props.handleSearch} /> */}
              </form>

              <div className="input-group-append bg-light ml-auto">
                <span
                  className="input-group-text  border-radius-none small text-white pointer"
                  style={{
                    backgroundColor: PrimaryTheme.primary,
                    fontSize: PrimaryTheme.fontSizes?.body,
                  }}
                  id="basic-addon1"
                  onClick={props.onClick}
                >
                  {" "}
                  <Icon
                    style={{
                      marginRight: 5,
                    }}
                  >
                    subject
                  </Icon>{" "}
                  Filter
                </span>
                <Tooltip title="Reset">
                  <IconButton onClick={props.onClear}>
                    <Icon fontSize="small">refresh</Icon>
                  </IconButton>
                </Tooltip>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

interface FilterProps {
  searchContent?: any;
  TraderPartnerSearch?: any;
  handleTraderPartnerSearchContent?: any;
  referenceValue?: any;
  isPosTransfer?: any;
  handlePosTransferSearch?: any;
  phoneValue?: any;
  terminalIdValue?: any;
  handlePhoneSearch?: any;
  searchDataTransfer?: any;
  searchData?: any;
  isPOS?: boolean;
  isTransaction?: boolean;
  name?: string;
  subtitle?: string;
  hasSearch?: boolean;
  onClick?: any;
  searchState?: string;
  dateState?: any;
  handleSearch?: any;
  handleSelect?: any;
  hasDownloads?: boolean;
  onDownload?: any;
  amount?: any;
  amountChange?: any;
  ranges?: any;
  // request
  isRequest?: boolean;
  recommended?: string;
  onRecommend?: any;
  hasDate?: boolean;
  isLogs?: boolean;
  hasSubtitle?: boolean;
  posState?: any;
  posStateChange?: any;
  posTarget?: any;
  posTargetChange?: any;
  onClear?: any;
  onTypeChange?: any;
  typeState?: any;
  typeItems?: Array<any>;
  transactionStatus?: any;
  transactionStatusChange?: any;
  status?: any;
  statusChange?: any;
  logType?: any;
  logTypeChange?: any;
  isDashboardPOSTransactions?: boolean;
  isDashboardTransafers?: any;
  poshasReference?: boolean;
  poshasStatus?: boolean;
  haschangeWidth?: any;
  isLocationDetails?: boolean;
  handleOpenModal?: any;
  isDashboardTransfer?: any;
  handleSearchTransfer?: any;
  searchText?: any;
  agentPhoneNumber?: string;
  handleAssignedAgentPhoneSearch?: any;
  handleSearchTID?: any;
  handleRefrenceChange?: any;
}
